export class AssignUserToProvider {
    public userID: string;
    public providerID: number;
}
